import React, { useContext, useEffect, useState } from 'react';
import _isEqual from 'lodash/isEqual';
import { PositionableTextDocument } from '@src/lib/PositionableTextDocument';
import { stylesToDefaultMarkValues } from '@src/utils/wysiwyg_editor/styles';
import RenderedText from '@src/components/wysiwyg_editor/page_content_items/text/RenderedText';

import { emptyDocument } from '@src/utils/proseMirror';

import { defaultMarkValues } from '@src/prose_mirror/schemas/TextSchema';
import { WysiwygEditorStateContext } from '@src/contexts/wysiwyg/editor';

import type { Props } from '../TextBox';

function Preview({ data }: Props): React.ReactElement {
  const { viewbox } = useContext(WysiwygEditorStateContext);
  const [textDocument, setTextDocument] = useState(() =>
    data.content
      ? PositionableTextDocument.fromPositionedDocument(data.content)
      : emptyDocument(
          data.styles?.align,
          stylesToDefaultMarkValues(defaultMarkValues, data.styles)
        )
  );
  const [textContent, setTextContent] = useState(
    () => textDocument.textContent
  );

  useEffect(() => {
    const newTextDocument = data.content
      ? PositionableTextDocument.fromPositionedDocument(data.content)
      : emptyDocument(
          data.styles?.align,
          stylesToDefaultMarkValues(defaultMarkValues, data.styles)
        );

    setTextDocument(newTextDocument);
    setTextContent(newTextDocument.textContent);
  }, [data.content, data.styles]);

  if (!textContent) return null;

  return (
    <g>
      {data.hideOverflow ? (
        <defs>
          <clipPath id={`clip-${data.id}`}>
            <rect
              x={data.contentLocation.x * viewbox.width}
              y={data.contentLocation.y * viewbox.height}
              height={data.contentLocation.height * viewbox.height}
              width={data.contentLocation.width * viewbox.width}
            />
          </clipPath>
        </defs>
      ) : null}

      <g clipPath={data.hideOverflow ? `url(#clip-${data.id})` : null}>
        <RenderedText
          backgroundColor={data.backgroundColor}
          editorContent={textDocument}
          textContent={textContent}
          location={data.contentLocation}
          viewbox={viewbox}
        />
      </g>
    </g>
  );
}

export default Preview;
